import { lazy } from "react";
import { Helmet } from "react-helmet";
import HomeHero from "../components/home/HomeHero";
import { LazySection } from "../components/reusables/LazySection";

const HomeAbout = lazy(() => import("../components/home/HomeAbout"));
const HomeSolutions = lazy(() => import("../components/home/HomeSolutions"));
const HomeWhyChooseUs = lazy(
  () => import("../components/home/HomeWhyChooseUs"),
);
const HomeTagline = lazy(() => import("../components/home/HomeTagline"));
const HomeIndustries = lazy(() => import("../components/home/HomeIndustries"));
const HomePartners = lazy(() => import("../components/home/HomePartners"));
const HomeContactCTA = lazy(() => import("../components/home/HomeContactCTA"));
const HomeTestimonials = lazy(
  () => import("../components/home/HomeTestimonials"),
);

export default function Home() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.ntuna.com" />
      </Helmet>
      {/* 🔥 Load instantly */}
      <HomeHero />

      {/* ⏳ Load each section independently */}
      <LazySection>
        <HomeAbout />
      </LazySection>

      <LazySection>
        <HomeSolutions />
      </LazySection>

      <LazySection>
        <HomeWhyChooseUs />
      </LazySection>

      <LazySection>
        <HomeTagline />
      </LazySection>

      <LazySection>
        <HomeIndustries />
      </LazySection>

      <LazySection>
        <HomeTestimonials />
      </LazySection>

      <LazySection>
        <HomePartners />
      </LazySection>

      <LazySection>
        <HomeContactCTA />
      </LazySection>
    </>
  );
}
